// scm-home-git.component.ts
import { Component, Input, OnInit } from '@angular/core';
import { UiService } from '../../../core/services/core.ui.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';

@Component({
    selector: 'scm-home-svn',
    template: require('./scm.home.svn.html')
})
export class ScmHomeSvnComponent implements OnInit {
    @Input() scm: any;
    @Input() user: any;
    @Input() scmData: any;
    @Input() project: any;
    @Input() protocol: string;
    /** Access instructions built by the parent ScmHomeComponent. */
    @Input() scmAccessText: any;

    protected checkoutUrl = '';

    ngOnInit(): void {
        this.checkoutUrl = this.getCheckoutUrl().trim();
    }

    constructor(
        private uiService: UiService,
        private gfTranslateService: GfTranslateService,
    ) {}

    private getCheckoutUrl() {
        if (this.scm.options.useSsh) {
            let portArg = '';
            if (this.scm.options.sshPort != 22) {
                // Produces a string like --config-option="config:tunnels:ssh=ssh -p 2200"
                // (note the double quotes wrapping the last chunk of the line above)
                portArg = `--config-option=\"config:tunnels:ssh=ssh -p ${ this.scm.options.sshPort }\"`;
            }
            return `svn checkout svn+ssh://${ this.user.unixName }@${ this.scm.hostName }/svnroot/${ this.project.unixName } ${ portArg }`;
        } else {
            let userName = this.user.unixName;
            if (this.scm.options.useExternalId) {
                userName = this.user.externalId;
            }
            return `svn checkout --username ${ userName } ${ this.protocol }//${ this.scmData.hostName }/svn/${ this.project.unixName }`;
        }
    }

    onCheckoutCopied(success: boolean): void {
        const message = this.gfTranslateService.translate(
            success ? 'Copied checkout URL to clipboard' : 'Unable to copy checkout URL to clipboard'
        );

        if (success) {
            this.uiService.message.showSuccess(message);
        } else {
            this.uiService.message.showError(message);
        }
    }
}
